<template>
    <ValidationObserver tag="form" ref="contenido" @submit.prevent="submit">
        <ContentOrLoading>
            <b-row v-if="!loading">
                <b-col cols="12" class="mt-2">

                    <div class="mb-3">
                        <button type="button" class="btn btn-outline-primary" @click="showModal('seleccionar-plantilla')">
                            <i class="fas fa-file-alt"></i> Seleccionar Plantilla
                        </button>
                    </div>

                    <b-tabs>
                        <b-tab title="Editor drag and drop" @click="cambiarTab('dragAndDrop')">
                            <label for="contenido" class="mt-3">Contenido del boletín</label>
                            <EmailGrapesJs v-model="boletinLocal.contenido" v-if="activeTab === 'dragAndDrop'" :key="grapesKey"/>
                        </b-tab>
                        <b-tab title="Previsualizar" @click="cambiarTab('preview')">
                            <div class="content-preview p-3" v-if="activeTab === 'preview'">
                                <div v-html="boletinLocal.contenido"></div>
                            </div>
                        </b-tab>
                    </b-tabs>                    
                </b-col>
                <b-col cols="12" class="mt-2 text-right">
                    <button id="continuar" class="button" type="submit" :disabled="loading">
                        <span>Continuar</span>
                    </button>
                </b-col>
                <b-col cols="6" class="mt-4 text-right ml-auto" v-if="error" >
                    <div class="alert alert-danger d-flex align-items-center justify-content-between m-0" role="alert">
                        <button @click="quitarError" class="button mr-4" >OK</button>
                        <p class="mb-0 ">Utiliza imágenes del gestor de medios para que se muestren correctamente.</p>
                    </div>
                </b-col>

            </b-row>

            <ModalComponent
                name="seleccionar-plantilla"
                title="Seleccionar Plantilla"
                @close="$modal.hide('seleccionar-plantilla')"
            >
                <div class="row">
                    <div class="col-12">
                        <div v-if="loadingPlantillas" class="text-center py-4">
                            <div class="spinner-border" role="status"></div>
                            <p class="mt-2">Cargando plantillas...</p>
                        </div>
                        <div v-else>
                            <div v-if="plantillas.length === 0" class="text-center py-4">
                                <p class="text-muted">No hay plantillas disponibles</p>
                            </div>
                            <div v-else>
                                <div class="form-group">
                                    <label for="plantilla-select">Selecciona una plantilla:</label>
                                    <select 
                                        id="plantilla-select"
                                        v-model="plantillaSeleccionada"
                                        class="form-control"
                                    >
                                        <option value="">-- Selecciona una plantilla --</option>
                                        <option 
                                            v-for="plantilla in plantillas" 
                                            :key="plantilla.id"
                                            :value="plantilla"
                                        >
                                            {{ plantilla.nombre || 'Sin nombre' }}
                                        </option>
                                    </select>
                                </div>
                                
                                <div v-if="plantillaSeleccionada" class="mt-3">
                                    <div class="card">
                                        <div class="card-body">
                                            <h6 class="card-title">{{ plantillaSeleccionada.nombre || 'Sin nombre' }}</h6>
                                            <p class="card-text text-muted" v-if="plantillaSeleccionada.description">
                                                {{ plantillaSeleccionada.description }}
                                            </p>
                                            <small class="text-muted">
                                                Creada: {{ plantillaSeleccionada.created_at }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="mt-4 text-right">
                                    <button 
                                        type="button" 
                                        class="btn btn-primary" 
                                        :disabled="!plantillaSeleccionada"
                                        @click="aplicarPlantilla"
                                    >
                                        <i class="fas fa-check"></i> Aplicar Plantilla
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </ContentOrLoading>
    </ValidationObserver>
</template>

<script>
    import EmailGrapesJs from "@/components/backend/components/EmailGrapesJs.vue";
    import ModalComponent from "@/components/backend/components/ModalComponent.vue";
    import apiService from '@/services/api-comunicados';
    

    export default {
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            boletin: {
                type: Object,
                required: true
            },
            error: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                boletinLocal: { ...this.boletin },
                activeTab: 'dragAndDrop',
                plantillas: [],
                loadingPlantillas: false,
                plantillaSeleccionada: "",
                grapesKey: 0
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.contenido.validate();

                if (isValid) {
                    this.$emit('update:boletin', this.boletinLocal);
                    this.$emit('finalizarPasoDos');
                }
            },

            showModal(modal) {
                this.plantillaSeleccionada = "";
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            cambiarTab(tab) {
                this.activeTab = tab;
            },

            async cargarPlantillas() {
                try {
                    this.loadingPlantillas = true;
                    
                    const response = await apiService.getListadoPlantillas({ to_select: "true" });
                    this.plantillas = response.data ;
                } catch (error) {
                    this.$toast.error("Error al cargar las plantillas");
                    this.plantillas = [];
                } finally {
                    this.loadingPlantillas = false;
                }
            },

            aplicarPlantilla() {
                if (!this.plantillaSeleccionada) return;
    
                this.boletinLocal.contenido = this.plantillaSeleccionada.html || this.plantillaSeleccionada.contenido || '';
                this.closeModal('seleccionar-plantilla');
                this.$toast.success(`Plantilla "${this.plantillaSeleccionada.nombre }" aplicada correctamente`);
                
                if (this.activeTab === 'dragAndDrop') {
                    this.grapesKey++;
                }
                this.$forceUpdate();
            },

            quitarError() {
                this.$emit('update:error', false);
            }
        },
        created(){
            this.cargarPlantillas();
        },
        watch: {
            'loading': {
                handler() {
                    this.cambiarTab('dragAndDrop');
                }
            }
        },

        components: {
            ModalComponent, EmailGrapesJs
        }
    }
</script>